import React from 'react';

const PageHero = ({ title, subtitle, image, defaultImage }) => {
  const defaultHeroImage = '/images/default-hero.jpg'; 
  
  return (
    <div className="relative h-[40vh] overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${image || defaultImage || defaultHeroImage})`,
        }}
      >
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-transparent"></div>
      </div>
      
      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center text-white px-4 z-10">
        <div className="max-w-3xl text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">{title}</h1>
          {subtitle && <p className="text-lg md:text-xl text-white/90">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};

export default PageHero;
